import { useEffect, useState } from 'react'
import {
  faJava,
  faCss3,
  faNodeJs,
  faHtml5,
  faJsSquare,
  faReact,
  faAws,
  faGithub
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I'm very ambitious front-end developer looking for a role in
            established IT company with the opportunity to work with the latest
            technologies on challenging and diverse projects.
          </p>
          <p align="LEFT">
            I'm quietly confident, naturally curious, and perpetually working on
            improving my chops one design problem at a time.
          </p>
          <p>
            If I need to define myself in one sentence that would be a sports fanatic,
            going to the gym, playing video games, and tech-obsessed!!!
          </p>
        </div>

        <div className="skills-container">
          <div className="skills">
            <div className="face">
              <FontAwesomeIcon icon={faJava} color="#8B0000"/>
            </div>
            <div className="face">
              <FontAwesomeIcon icon={faHtml5} color="#F06529" />
            </div>
            <div className="face">
              <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
            </div>
            <div className="face">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face">
              <FontAwesomeIcon icon={faNodeJs} color="#3c873a" />
            </div>
            <div className="face">
              <FontAwesomeIcon icon={faAws} color="#FF9900" />
            </div>
            <div className="face">
              <FontAwesomeIcon icon={faGithub} color="#000" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
